<template>
  <div id="group-info" class="data-list-container vs-con-loading__container">
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6 ml-6">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/after-login">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex items-end">
              <router-link to="/group" class="mb-1">
                <span class="breadcrumb-separator mx-2 mr-1 text-primary">Group</span>
               </router-link>
              <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">{{ this.$route.query.name }}</span>
            </li>
        </ul>
    </div>
    <!-- <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-base mx-5">
      <h1>{{ this.$route.query.name }}</h1>
    </div> -->
    <vs-table :data="groupMemberList" multiple :max-items="itemsPerPage" v-model="deleteSelect">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
        <div class="flex add-delete">
          <vs-button
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addNewToGr"
            class="add-new-btn gradient gradient-primary no-shadow mb-4"
          >Add New</vs-button>
          <div style="position: relative">
          <transition name="list">
          <vs-button
            type="border"
            @click="popupActive1=true"
            color="danger"
            class="delete-btn gradient gradient-danger no-shadow mb-4"
            v-show="deleteSelect.length != 0"
          >Delete Customer</vs-button>
          </transition>
          </div>
        </div>
        <vs-popup class="holamundo delete-customer delete-popup" title="Delete Customer From Group" :active.sync="popupActive1">
          <div class="text-center">
              <h3>Do you want to delete <span v-if="deleteSelect.length < 2">this customer</span> <span v-else>these customers</span>?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <vs-button class="mr-6 align-center delete-responsive" @click="deleteSelected">Delete</vs-button>
              <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupActive1 = false">Cancel</vs-button>
              </div>
          </div>
        </vs-popup>
        <vs-popup class="add-customer-to-group" title="Add Customer To Group" :active.sync="popupActive">
          <vs-table
            :data="customersList"
            multiple
            :max-items="customer_itemsPerPage"
            v-model="selected"
            id="add-customer-gr"
            class="vs-con-loading__container"
          >
            <div
              slot="header"
              class="flex flex-wrap-reverse items-center flex-grow justify-between"
            >
              <vs-button
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                @click="addSelected"
                class="gradient gradient-primary no-shadow"
              >Add Selected</vs-button>

              <div class="con-input-search vs-table--search">
                <input
                  type="text"
                  class="input-search vs-table--search-input rounded-item"
                  @keyup="searchCustomerAdd"
                  placeholder="Search customer"
                  v-model="searchAdd"
                />
                <i class="vs-icon notranslate icon-scale material-icons null">search</i>
              </div>
            </div>
            <template slot="thead">
              <vs-th><span class="text-uppercase">Customer Name</span></vs-th>
              <vs-th><span class="text-uppercase">Phone</span></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="customer" :key="indextr" v-for="(customer, indextr) in data">
                <vs-td :data="data[indextr].full_name">{{ customer.full_name }}</vs-td>

                <vs-td :data="data[indextr].phone">{{ StringHelper.phoneNumberFormat(customer.phone) }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div v-if="customersData._meta.pageCount">
            <!-- <vs-pagination
              class="custom-pagination"
              :total="parseInt(customersData._meta.pageCount)"
              v-model="customer_currentPage"
              @click.native="changeCustomerPage(customer_currentPage, customer_itemsPerPage)"
            ></vs-pagination> -->
            <custom-pagination class="custom-pagination mt-6"
            :totalPages="parseInt(customersData._meta.pageCount)" :currentPage="customer_currentPage"
             @pageChanged="changeCustomerPage" :key="page_customer_key"></custom-pagination>
          </div>
        </vs-popup>

        <div class="flex perpage-search">
          <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown mb-4" v-if="groupInfo._meta.totalCount > 0 && !config.hide_customer_statistic">
            <div
              class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              style="min-width: 150px"
            >
              <span
                class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ groupInfo._meta.totalCount - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : groupInfo._meta.totalCount }} of {{ groupInfo._meta.totalCount }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="(item, i) in options"
                :key="i"
                @click="changeItemsPerPage(currentPage = 1, itemsPerPage=item)"
                v-model="itemsPerPage"
              >
                <span class="w-full flex justify-between" :class="{'text-primary': itemsPerPage == item}">
                  {{item}}
                  <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="itemsPerPage == item"/>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div class="con-input-search vs-table--search mb-4">
            <input
              type="text"
              class="input-search vs-table--search-input"
              @keyup="searchCustomer"
              :value="search"
              placeholder="Search customer"
            />
            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
          </div>
        </div>
      </div>
      <template slot="thead">
        <vs-th class="text-center">Customer Name</vs-th>
        <vs-th class="text-center">Phone</vs-th>
        <vs-th class="center-title text-center">Point</vs-th>
        <vs-th class="center-title text-center">Life Time Point</vs-th>
      </template>
      <template slot-scope="{data}">
        <!-- <vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="updateActiveCustomer(tr)"> -->
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md">

          <vs-td :data="data[indextr].full_name">{{ tr.full_name }}</vs-td>

          <vs-td :data="data[indextr].phone">{{ StringHelper.phoneNumberFormat(tr.phone) }}</vs-td>

          <vs-td class="text-center" v-if="tr.current_point != null" :data="data[indextr].point">{{ tr.current_point }}</vs-td>
          <vs-td class="text-center" v-else :data="data[indextr].point">0</vs-td>
          <vs-td class="text-center" v-if="tr.lifetime_point != null" :data="data[indextr].lifetime_point">{{ tr.lifetime_point }}</vs-td>
          <vs-td class="text-center" v-else :data="data[indextr].lifetime_point">0</vs-td>

        </vs-tr>
      </template>
    </vs-table>
    <div v-if="this.groupMemberList.length > 0">
      <!-- <vs-pagination
        class="custom-pagination"
        :total="parseInt(groupInfo._meta.pageCount)"
        v-model="currentPage"
        @click.native="changePage(currentPage, itemsPerPage)"
      ></vs-pagination> -->
      <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(groupInfo._meta.pageCount)"
       :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>
  </div>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
export default {
  data() {
    return {
      itemsPerPage: 10,
      itemsPerPage1: 10,
      popupActive: false,
      popupActive1: false,
      id: 0,
      selected: [],
      deleteSelect: [],
      list: [],
      currentPage: 1,
      deleteCurrentPage: 1,
      deleteItemsPerPage: 10,
      customer_currentPage: 1,
      customer_itemsPerPage: 10,
      options: [ 10,15,20],
      search: '',
      searchAdd: '',
      activeCustomer: {},
      StringHelper,
      items: [
        {
          title: 'Home',
          url: '/',
          icon: "HomeIcon",
        },
        {
          title: 'Group',
          url: '/group',
        },
        {
          title: 'Group Info',
          active: true,
        },
      ],
      action_type: '',
      isOpenLoading: false,
      page_key: 0,
      page_customer_key:0,
      loaded_data_num: 0
    };
  },
  computed: {
    customersData() {
      return this.$store.getters["customerList/customerData"];
    },
    groupMemberList() {
      return this.$store.getters["customerList/groupMember"];
    },
    groupInfo() {
      return this.$store.getters["customerList/groupInfo"];
    },
    deleteGroupMemberList() {
      return this.$store.getters["customerList/deleteGroupMember"];
    },
    deleteGroupInfo() {
      return this.$store.getters["customerList/deleteGroupInfo"];
    },
    customersList() {
      return this.$store.getters["customerList/customerList"];
    },
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  watch: {
    // dataChange: {
    //   immediate: true,
    //   deep: true,
    //   handler: function () {
    //     // if(this.dataChange) {
    //       // console.log(this.dataChange.message);
    //     // }
    //     // if(this.dataChange && this.dataChange.message == 'afterInsert') {
    //     if(this.dataChange) {
    //       const obj = {
    //         id: this.$route.query.id,
    //         page: this.currentPage,
    //         "per-page": this.itemsPerPage,
    //         keyword: this.search,
    //       };
    //       this.$store.dispatch("customerList/GET_A_GROUP_DETAIL", obj)
    //     }
    //   },
    // },
    popupActive: {
        immediate: true,
        deep: true,
        handler() {
            this.selected = [];
            this.list = [];
            if(this.popupActive) {
                this.customer_currentPage = 1;
                document.body.classList.add('overflow-hidden');
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
                const obj = {
                  id: this.$route.query.id,
                  page: this.customer_currentPage,
                  "per-page": this.itemsPerPage,
                  keyword: this.search,
                };
                this.$store.dispatch('customerList/GET_CUSTOMER_LIST_NOT_IN_GROUP',obj)
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        }
    },
     popupActive1: {
        immediate: true,
        deep: true,
        handler() {
            // this.deleteSelect = [];
            this.list = [];
            if(this.popupActive1) {
                document.body.classList.add('overflow-hidden');
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        }
    },
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 3) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    addNewToGr(){
      this.popupActive = true;
      this.searchAdd = '';
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' customer failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' customer failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    updateActiveCustomer(customer) {
      this.activeCustomer = customer;

      // console.log(customer)
      // let index = -1;
      // for(let i = 0; i < this.deleteSelect.length; i++) {
      //   if(!this.deleteSelect[i]) {
      //     this.deleteSelect.splice(i, 1);
      //   }
      //   if(this.deleteSelect[i] && this.deleteSelect[i].id == customer.id) {
      //     index = i;
      //   }
      // }
      // if(index != -1) {
      //   this.deleteSelect.splice(index, 1);
      // } else {
      //   this.deleteSelect.push(customer);
      // }
      // console.log(this.deleteSelect)
    },
    searchCustomer({target}){
      this.deleteSelect = [];
      this.search = target.value;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      // this.$vs.loading({
      //   container: "#app",
      //   scale: 0.8
      // });
      if(!this.isOpenLoading){
        this.openLoadingInDiv();
      }
      this.action_type = "Search";
      this.timer = setTimeout(() => {
        this.currentPage = 1;
        // this.search = target.value;
        const obj={
          id: this.$route.query.id,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          keyword: target.value
        }
        this.$store.dispatch('customerList/GET_A_GROUP_DETAIL',obj).then(() => {
          // this.$vs.loading.close("#app > .con-vs-loading");
          this.closeLoading();
        });
      }, 500);
      // this.currentPage = 1;
      // this.search = target.value;
      // const obj={
      //   id: this.$route.query.id,
      //   page: this.currentPage,
      //   "per-page": this.itemsPerPage,
      //   keyword: target.value
      // }
      // this.openLoadingInDiv();
      // this.$store.dispatch('customerList/GET_A_GROUP_DETAIL',obj).then(() => {
      //   this.closeLoading();
      // })
    },
    searchCustomerAdd({target}){
      this.selected = [];
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.$vs.loading({
        container: "#add-customer-gr",
        scale: 0.8
      });
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
          if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.notify({
              title:'Notification',
              text: 'Search customer failed',
              color:'danger',
              position:'top-right'})
          }
      }, 10000);
      this.timer = setTimeout(() => {
        this.customer_currentPage = 1;
        const obj={
          id: this.$route.query.id,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          keyword: target.value
        }
        this.$store.dispatch('customerList/GET_CUSTOMER_LIST_NOT_IN_GROUP',obj).then(() => {
          this.$vs.loading.close("#add-customer-gr > .con-vs-loading");
          this.isOpenLoading = false;
        });
      }, 500);
      // const obj = {
      //   id: this.$route.query.id,
      //   page: this.currentPage,
      //   "per-page": this.itemsPerPage,
      //   keyword: target.value
      // }
      // this.openLoadingInDiv();
      // this.$store.dispatch('customerList/GET_CUSTOMER_LIST_NOT_IN_GROUP',obj).then(() => {
      //   this.closeLoading();
      // })
    },
    changeCustomerPage(customer_currentPage) {
      const obj = {
        id: this.$route.query.id,
        page: customer_currentPage,
        "per-page": this.itemsPerPage,
        keyword: this.searchAdd
      };
      this.selected = [];
      this.openLoadingInDiv();
      this.action_type = "Get list";
      this.$store.dispatch("customerList/GET_CUSTOMER_LIST_NOT_IN_GROUP", obj).then(() => {
        this.closeLoading();
        this.page_customer_key++;
        this.customer_currentPage = customer_currentPage;
      })
    },
    changeDeletePage(deleteCurrentPage, deleteItemsPerPage){
      const obj = {
        id: this.$route.query.id,
        page: deleteCurrentPage,
        "per-page": deleteItemsPerPage,
        keyword: this.search
      };
      this.deleteSelect = [];
      this.openLoadingInDiv();
      this.$store.dispatch("customerList/GET_A_DELETE_GROUP_DETAIL", obj).then(() => {
        this.closeLoading();
      })
    },
    changePage(currentPage) {
      this.deleteSelect = [];
      const obj = {
        id: this.$route.query.id,
        page: currentPage,
        "per-page": this.itemsPerPage,
        keyword: this.search
      };
      this.openLoadingInDiv();
      this.action_type = "Get list";
      this.$store.dispatch("customerList/GET_A_GROUP_DETAIL", obj).then(() => {
        this.closeLoading();
        this.page_key++;
        this.currentPage = currentPage;
      })
    },
    changeItemsPerPage(currentPage, itemsPerPage) {
      const obj = {
        id: this.$route.query.id,
        page: currentPage,
        "per-page": itemsPerPage,
        keyword: this.search
      };
      this.openLoadingInDiv();
      this.action_type = "Get list";
      this.$store.dispatch("customerList/GET_A_GROUP_DETAIL", obj).then(() => {
        this.closeLoading();
        this.currentPage = currentPage;
        this.page_key++;
      })
    },
    // checkExist(item, arr){
    //   for(let i=0; i< arr.length; i++) {
    //     if(item.id == arr[i].id) {
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    handleSelected(tr) {
      this.$vs.notify({
        title: `Selected ${tr.full_name}`,
        text: `Phone: ${tr.phone}`
      });
    },
    closePopup() {
      this.popupActive = false;
    },
    // closePopup1() {
    //   this.popupActive1 = false;
    // },
    // addCustomerToGroup(tr) {
    //   const obj = {
    //     customer_id: tr.id,
    //     name: tr.full_name,
    //     id: this.$route.query.id,
    //     page: this.currentPage,
    //     "per-page": this.itemsPerPage
    //   };
    //   this.closePopup();
    //   this.openLoadingInDiv();
    //   this.$store.dispatch("customerList/UPDATE_A_GROUP", obj).then(() => {
    //     this.closeLoading();
    //   })
    // },
    addSelected() {
      for (let i = 0; i < this.selected.length; i++) {
        this.list.push(this.selected[i].id);
      }
      // console.log(this.list);
      const obj = {
        id: this.$route.query.id,
        customer_ids: String(this.list),
        page: this.currentPage,
        "per-page": this.customer_itemsPerPage,
        keyword: this.search,
        searchqAdd : this.searchAdd
      }
      this.openLoadingInDiv();
      this.action_type = 'Add';
      this.$store.dispatch("customerList/UPDATE_A_GROUP", obj).then(() => {
        this.closeLoading();
        this.closePopup();
        this.$vs.notify({
          title:'Notification',
          text:'Add Customer Success',
          color:'success',
          position:'top-right'})
      }).catch(() => {
        this.closeLoading();
        this.closePopup();
      })
      this.list = [];
      this.selected = [];
      this.customer_currentPage = 1;
    },
    deleteSelected() {
      // console.log(this.deleteSelect)
      for (let i = 0; i < this.deleteSelect.length; i++) {
        this.list.push(this.deleteSelect[i].id);
      }
      // console.log(this.list);
      // this.closePopup();
      const obj = {
        id: this.$route.query.id,
        customer_ids: String(this.list),
        page: 1,
        "per-page": this.deleteItemsPerPage,
        keyword: this.search,
        searchqAdd : this.searchAdd
      }
      this.deleteCurrentPage = 1 ;
      this.currentPage = 1;
      this.openLoadingInDiv();
      this.action_type = "Delete";
      this.$store.dispatch("customerList/DELETE_A_CUSTOMER", obj).then(() => {
        this.closeLoading();
        this.popupActive1 = false
        this.$vs.notify({
          title:'Notification',
          text:'Delete Customer Success',
          color:'danger',
          position:'top-right'})
      }).catch(() => {
        this.closeLoading();
        this.popupActive1 = false
      })
      this.list = [];
      this.deleteSelect = [];
      // this.popupActive1 = false
    },
    // deleteCustomer() {
    //   const obj = {
    //     id: this.$route.query.id,
    //     customer_ids: this.activeCustomer.id,
    //     page: this.currentPage,
    //     "per-page": this.itemsPerPage,
    //     keyword: this.search,
    //     searchqAdd : this.searchAdd
    //   }
    //   this.openLoadingInDiv();
    //   this.$store.dispatch("customerList/DELETE_A_CUSTOMER",obj).then(() => {
    //     this.closeLoading();
    //   })
    //   this.popupActive1 = false
    // }
  },
  created() {
    const obj = {
      id: this.$route.query.id,
      page: this.currentPage,
      "per-page": this.itemsPerPage,
      keyword: this.search,
    };
    this.$store.dispatch("customerList/GET_A_GROUP_DETAIL", obj).then(() => {
      this.loaded_data_num++;
    });
    this.$store.dispatch("customerList/GET_A_DELETE_GROUP_DETAIL", obj).then(() => {
      this.loaded_data_num++;
    })
    this.$store.dispatch("customerList/GET_CUSTOMER_LIST_NOT_IN_GROUP", obj).then(() => {
      this.loaded_data_num++;
    })
  }
};
</script>